var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import Lottie from 'lottie-web';
import URLCache from "../helpers/URLCache";
import { styled } from '../theme/ThemeHelpers';
import { appendPx } from '../theme/DefaultTheme';
import LottieActivity from "./lottiIcons/LottieActivity";
import LottieAddRating from "./lottiIcons/LottieAddRating";
import LottieRadiobutton from "./lottiIcons/LottieRadiobutton";
import LottieInfoWarning from "./lottiIcons/LottieInfoWarning";
import LottieInfoSuccess from "./lottiIcons/LottieInfoSuccess";
import LottieInfoInformation from "./lottiIcons/LottieInfoInformation";
import LottieInfoError from "./lottiIcons/LottieInfoError";
import LottieFingerPrint from "./lottiIcons/LottieFingerPrint";
import LottieEyeBlinking from "./lottiIcons/LottieEyeBlinking";
import LottieCheckbox from "./lottiIcons/LottieCheckbox";
export var imgLottieDefs = {
    "Activity": LottieActivity,
    "Radiobutton": LottieRadiobutton,
    "InfoWarning": LottieInfoWarning,
    "InfoSuccess": LottieInfoSuccess,
    "AddRating": LottieAddRating,
    "InfoInformation": LottieInfoInformation,
    "InfoError": LottieInfoError,
    "FingerPrint": LottieFingerPrint,
    "EyeBlinking": LottieEyeBlinking,
    "Checkbox": LottieCheckbox
};
var IconDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    ", ";\n"], ["\n    ", ";\n    ", ";\n"])), function (props) { return props.width ? "width: " + appendPx(props.width) : ""; }, function (props) { return props.height ? "height: " + appendPx(props.height) : ""; });
var LottieIcon = /** @class */ (function (_super) {
    __extends(LottieIcon, _super);
    function LottieIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mounted = false;
        _this.state = {
            json: undefined,
        };
        _this.setRef = function (ref) {
            _this.ref = ref;
            _this.animation = Lottie.loadAnimation({
                container: _this.ref,
                animationData: _this.state.json,
                autoplay: _this.props.autoplay ? _this.props.autoplay : false,
                loop: _this.props.loop ? _this.props.loop : false,
                renderer: "svg",
            });
            if (_this.props.speed)
                _this.animation.setSpeed(_this.props.speed);
            if (_this.props.direction)
                _this.animation.setDirection(_this.props.direction);
        };
        _this.play = function (direction) {
            var _a, _b;
            if (_this.animation) {
                var e = (_a = _this.props.animEnd) !== null && _a !== void 0 ? _a : _this.animation.getDuration(true);
                var s = (_b = _this.props.animStart) !== null && _b !== void 0 ? _b : 0;
                if (e > 0) {
                    if (direction === undefined || direction > 0)
                        _this.animation.playSegments([s, e], true);
                    else
                        _this.animation.playSegments([e, s], true);
                }
            }
        };
        _this.stop = function () {
            if (_this.animation)
                _this.animation.stop();
        };
        _this.pause = function (val) {
            if (_this.animation) {
                if (val)
                    _this.animation.pause();
                else
                    _this.animation.play();
            }
        };
        return _this;
    }
    LottieIcon.prototype.componentDidMount = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var json, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.mounted = true;
                        if (!this.props.json && !this.props.url)
                            throw "Either json or url must be supplied as parameter!";
                        if (!((_a = this.props.json) !== null && _a !== void 0)) return [3 /*break*/, 1];
                        _c = _a;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, LottieIcon.cache.get((_b = this.props.url) !== null && _b !== void 0 ? _b : "")];
                    case 2:
                        _c = _d.sent();
                        _d.label = 3;
                    case 3:
                        json = _c;
                        if (this.mounted)
                            this.setState({ json: json });
                        if (this.props.getMethods)
                            this.props.getMethods(this.play, this.stop, this.pause);
                        return [2 /*return*/];
                }
            });
        });
    };
    LottieIcon.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    LottieIcon.prototype.render = function () {
        // Show LottieIcon by Name if possible
        if (this.animation) {
            if (this.props.speed)
                this.animation.setSpeed(this.props.speed);
            if (this.props.direction)
                this.animation.setDirection(this.props.direction);
        }
        if (!this.state.json)
            return React.createElement("div", null);
        return (React.createElement(IconDiv, { ref: this.setRef, width: this.props.width, height: this.props.height }));
    };
    LottieIcon.cache = new URLCache();
    return LottieIcon;
}(React.PureComponent));
export default LottieIcon;
var templateObject_1;
//# sourceMappingURL=LottieIcon.js.map